import { render, staticRenderFns } from "./Erp6SaleBaseCustomerInfoEdit.vue?vue&type=template&id=5d5f1c82&scoped=true&"
import script from "./Erp6SaleBaseCustomerInfoEdit.vue?vue&type=script&lang=js&"
export * from "./Erp6SaleBaseCustomerInfoEdit.vue?vue&type=script&lang=js&"
import style0 from "./Erp6SaleBaseCustomerInfoEdit.vue?vue&type=style&index=0&id=5d5f1c82&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5f1c82",
  null
  
)

export default component.exports